import { render } from "./ConsoleTemplateView.vue?vue&type=template&id=0b3535f8&ts=true"
import script from "./ConsoleTemplateView.vue?vue&type=script&lang=ts"
export * from "./ConsoleTemplateView.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src553776015/src/CheckAddressConsole/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__